import ResourcePage from "@/components/ResourcePage";

/**
 * Partner ist eine Organisation bzw. Beziehung – nicht eine doppelte Personenkartei.
 *  - Partnerorganisation = Firma (Auswahl oder Inline-Anlage)
 *  - Ansprechpartner = existierender Kontakt (kein zusätzliches contact_person-Textfeld)
 *  - E-Mail/Telefon/Website liegen in der zugehörigen Firma bzw. Person – hier nicht doppelt.
 *  - Notiz erklärt die Beziehung, Rolle und Absprachen.
 */
export default function PartnersPage() {
  return (
    <ResourcePage
      resource="partners"
      title="Partner"
      subtitle="Wer arbeitet mit dir zusammen – Rolle, Ansprechpartner, Absprachen."
      singular="Partner"
      newButtonLabel="Partner anlegen"
      createDialogTitle="Partner anlegen"
      editDialogTitle="Partner bearbeiten"
      submitButtonLabel="Partner speichern"
      emptyDescription="Lege deinen ersten Partner an."
      emptyCreateButtonLabel="Partner anlegen"
      testidPrefix="partners"
      fields={[
        { name: "name", label: "Bezeichnung der Beziehung", type: "text", required: true, placeholder: "z. B. Agentur XYZ – Kreativpartner", fullWidth: true },
        { name: "type", label: "Rolle / Typ", type: "text", placeholder: "z. B. Agentur, Lieferant, Vertrieb" },
        {
          name: "company_id",
          label: "Partnerorganisation (Firma)",
          type: "select",
          optionsFromResource: "companies",
          allowNone: { label: "— Keine zugeordnete Firma —" },
          placeholder: "Firma wählen…",
          withInlineCreate: {
            resource: "companies",
            singular: "Firma",
            buttonLabel: "Firma anlegen",
            defaults: { country: "Deutschland" },
            fields: [
              { name: "name", label: "Firmenname", type: "text", required: true },
              { name: "industry", label: "Branche", type: "text" },
              { name: "website", label: "Website", type: "text" },
              { name: "email", label: "E-Mail", type: "email" },
              { name: "phone", label: "Telefon", type: "tel" },
            ],
          },
        },
        {
          name: "primary_contact_id",
          label: "Ansprechpartner (Person)",
          type: "select",
          optionsFromResource: "contacts",
          optionLabel: (c) => [c.salutation, c.title, c.first_name, c.last_name].filter(Boolean).join(" ") + (c.company_name ? ` – ${c.company_name}` : ""),
          allowNone: { label: "— Kein fester Ansprechpartner —" },
          placeholder: "Kontakt wählen…",
        },
        {
          name: "notes",
          label: "Partnernotiz: Welche Beziehung, welche Rolle, was ist vereinbart?",
          type: "textarea",
          fullWidth: true,
          rows: 4,
          placeholder: "Kurz beschreiben: Wer ist der Partner, welche Rolle hat er, welche Absprachen bestehen?",
        },
      ]}
      columns={[
        { key: "name", label: "Beziehung", render: (r) => <span className="font-medium text-gray-900">{r.name}</span> },
        { key: "type", label: "Rolle" },
        { key: "company_name", label: "Firma", render: (r) => r.company_name || "—" },
        { key: "primary_contact_name", label: "Ansprechpartner", render: (r) => r.primary_contact_name || "—" },
      ]}
    />
  );
}
